import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { CustomerModel } from '../models/customer.model';

export class CustomersApiService extends ApiService {
  static endpoint = 'customers';

  /**
   * @param {Number|null} customerId
   * @return {String}
   * @protected
   */
  static buildCustomerUrl(customerId = null) {
    return this.buildUrl(customerId);
  }

  /**
   * @param {String|Number} customerId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CustomerModel>>}
   * @public
   */
  static async getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCustomerUrl(), {
      ...config,
      dataModel: CustomerModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
